import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ component: Component, ...rest}) => (
  <Route {...rest} render={(props) => (
    sessionStorage.athenasToken ? <Component {...props} {...rest}/> : <Redirect to='/login'/> 
  )}/>
)
export default PrivateRoute;